__turbopack_context__.v({
  "container": "vqSz9G_container",
  "description": "vqSz9G_description",
  "value": "vqSz9G_value",
  "valueLong": "vqSz9G_valueLong",
});
